export default __webpack_public_path__ + "static/media/adrobot_background_fr.1b722020.png";